export class Arquivo {
    id: number;
    nome: string;
    tamanho: string;
    tipoDeDocumento: string;
    valor: string;
    extensao: string;
    cnpj: string;
    numeroContrato: string;
    primeiroAditivo: string;
    segundoAditivo: string;
}



// WEBPACK FOOTER //
// ./src/app/_classes/arquivo.ts